import { ButtonBase, Stack } from "@mui/material";

import { TimekeepingActionButton } from "../TimekeepingActionButton";

interface BreakActionsProps {
  isOnBreak: boolean;
  hasEndedBreak: boolean;
  hasSkippedBreak: boolean;
  onStartBreak: () => void;
  onEndBreak: () => void;
  onSkipBreak: () => void;
}

export function BreakActions(props: BreakActionsProps) {
  const { isOnBreak, hasEndedBreak, hasSkippedBreak, onStartBreak, onEndBreak, onSkipBreak } =
    props;

  // improve this logic
  const showStartBreakButton = !isOnBreak && !hasEndedBreak && !hasSkippedBreak;
  const showEndBreakButton = isOnBreak;
  const showSkipBreakButton = !isOnBreak && !hasEndedBreak && !hasSkippedBreak;

  return (
    <Stack spacing={2}>
      {showStartBreakButton && (
        <TimekeepingActionButton title="Start break" onClick={onStartBreak} />
      )}

      {showEndBreakButton && <TimekeepingActionButton title="End break" onClick={onEndBreak} />}

      {showSkipBreakButton && (
        <ButtonBase
          LinkComponent="button"
          sx={{ fontSize: "16px", fontWeight: 500, paddingY: 5, paddingX: 8 }}
          onClick={onSkipBreak}
        >
          Skip break
        </ButtonBase>
      )}
    </Stack>
  );
}
